import { useEffect } from "react";

function upsertMeta(name, content, property = false) {
  if (!content) {
    return;
  }

  const selector = property ? `meta[property="${name}"]` : `meta[name="${name}"]`;
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement("meta");
    if (property) {
      element.setAttribute("property", name);
    } else {
      element.setAttribute("name", name);
    }
    document.head.appendChild(element);
  }

  element.setAttribute("content", content);
}

function upsertLink(rel, href) {
  if (!href) {
    return;
  }

  let element = document.head.querySelector(`link[rel="${rel}"]`);

  if (!element) {
    element = document.createElement("link");
    element.setAttribute("rel", rel);
    document.head.appendChild(element);
  }

  element.setAttribute("href", href);
}

export function useWeatherPublicSeo({
  title,
  description,
  canonicalPath = "/weather/sources",
} = {}) {
  useEffect(() => {
    const previousTitle = document.title;
    const canonicalUrl =
      typeof window !== "undefined"
        ? `${window.location.origin}${canonicalPath}`
        : canonicalPath;

    if (title) {
      document.title = title;
    }

    upsertMeta("description", description);
    upsertMeta("robots", "index,follow");
    upsertLink("canonical", canonicalUrl);
    upsertMeta("og:title", title, true);
    upsertMeta("og:description", description, true);
    upsertMeta("og:url", canonicalUrl, true);
    upsertMeta("og:type", "website", true);
    upsertMeta("twitter:card", "summary");
    upsertMeta("twitter:title", title);
    upsertMeta("twitter:description", description);

    return () => {
      document.title = previousTitle;
    };
  }, [canonicalPath, description, title]);
}

export default useWeatherPublicSeo;
